export default __webpack_public_path__ + "static/media/cc.97b04caf.jpg";